// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"014b9eda","936":"725214fc","969":"b14e39e5"}[chunkId] + ".chunk.js";
};